var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "container seg-content general user" }, [
      _c(
        "section",
        { staticClass: "home-list" },
        [
          _c(
            "router-link",
            {
              staticClass: "new-button",
              attrs: {
                to: { name: "content.postedit", params: { id: "new-post" } }
              }
            },
            [_vm._v("Add New Post")]
          ),
          _vm._v(" "),
          _c("post-list", { attrs: { type: "video" } })
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }